import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { routes } from 'flow/types/routes';
import CallHistoryV2 from './call-history-v2/CallHistoryV2';
import ExtensionListTab_TW from './nav/ExtensionListTab';
import PbxNavigation from './nav/PbxNavigation';
import Sessions from './nav/Sessions';
import SettingsNavigation from './nav/SettingsNavigation';
import TicketsListsSection_TW from './nav/TicketsListsSection';
import { isExtensionKey } from 'flow/utils';
import { CENTRAL_SWITCH_OVERVIEW_KEY } from './nav/contact-list/contact-list-rows';

// The contact list's open item. The Overview opens at the list's own route
// too, with no key in it.
const openExtensionListItem = (entityKey, setting) => {
    if (isExtensionKey(entityKey)) {
        return entityKey;
    }
    if (entityKey === undefined || entityKey === 'overview') {
        return CENTRAL_SWITCH_OVERVIEW_KEY;
    }
    return setting;
};

const Navigator = (props) => {
    const { entityKey, setting } = props;

    return (
        <Switch>
            <Route
                path={routes['extensions']}
                render={(props) => (
                    <ExtensionListTab_TW
                        {...props}
                        selected={openExtensionListItem(entityKey, setting)}
                    />
                )}
            />
            <Route
                path={[
                    routes['messages.id'],
                    routes['messages'],
                    routes['videoLink'],
                ]}
                render={(props) => <Sessions {...props} />}
            />
            <Route
                path={[routes['pbx.navigation'], routes['pbx']]}
                render={() => <PbxNavigation />}
            />
            <Route
                path={[routes['calls.callRecordKey'], routes['calls']]}
                render={() => <CallHistoryV2 />}
            />
            <Route
                path={routes['tickets']}
                render={(props) => (
                    <TicketsListsSection_TW {...props} selected={setting} />
                )}
            />

            <Route
                path={[routes['settings'], '/settings']}
                render={(props) => (
                    <SettingsNavigation {...props} selected={setting} />
                )}
            />
        </Switch>
    );
};

Navigator.propTypes = {
    defaultTab: PropTypes.oneOf([
        'extensions',
        'messages',
        'pbx',
        'calls',
        'settings',
        'start',
        'omni',
        'tickets',
    ]),
    entityKey: PropTypes.string,
    setting: PropTypes.string,
};

export default React.memo(Navigator);
